import "/home/runner/work/pocket-dimension-dice/pocket-dimension-dice/components/Rollable/styles.module_built.css";
const classes = {"button":"F8U5pq_button"}
export default classes

const _button0 = classes["button"]
export { _button0 as "button" }
